import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import './skeleton'
import { SkeletonPreset } from './skeleton-preset'

/**
 * Renders `count` uniform row skeletons stacked vertically.
 * Override row height per instance: `<schmancy-skeleton-list class="[--row:48px]">`
 */
@customElement('schmancy-skeleton-list')
export class SchmancySkeletonList extends SkeletonPreset {
	static styles = [
		css`
			:host {
				display: flex;
				flex-direction: column;
				gap: 0.5rem;
			}
			schmancy-skeleton {
				height: var(--row, 64px);
				border-radius: var(--schmancy-radius-xl, 0.875rem); /* mirrors --radius-xl (rounded-xl) */
			}
		`,
	]

	render() {
		return html`${Array.from(
			{ length: this.count },
			() => html`<schmancy-skeleton class="w-full"></schmancy-skeleton>`,
		)}`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-skeleton-list': SchmancySkeletonList
	}
}
